import { render, staticRenderFns } from "./ExerciseCard.vue?vue&type=template&id=2afbd7d4"
import script from "./ExerciseCard.vue?vue&type=script&lang=js"
export * from "./ExerciseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports